import { doc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';

export function generateCompanyId(companyName: string): string {
  const cleanName = companyName.replace(/[^a-zA-Z]/g, '').toUpperCase();
  const namePrefix = cleanName.substring(0, 4).padEnd(4, 'X');
  const randomNumbers = Math.floor(1000 + Math.random() * 9000);
  return `${namePrefix}-${randomNumbers}`;
}

export async function generateUniqueId(collectionName: string): Promise<string> {
  const ref = doc(collection(db, collectionName));
  return ref.id;
}

export async function checkIfExists(collectionName: string, field: string, value: string): Promise<boolean> {
  try {
    const querySnapshot = await getDocs(
      query(collection(db, collectionName), where(field, '==', value))
    );
    return !querySnapshot.empty;
  } catch (error) {
    console.error('Chyba pri kontrole existencie:', error);
    return false;
  }
}

